export const FifteenMinMode = {
  slots: 4,
  increments: 15,
} as const;

export const FiveMinMode = {
  slots: 12,
  increments: 5,
} as const;

export const DayWeekMode = FifteenMinMode;

export const CalendarScheduleModes = {
  AVAILABILITY: 'availability',
  INTERVIEW: 'interview',
} as const;

export const CalendarScheduleModeOptions = [
  {
    id: CalendarScheduleModes.AVAILABILITY,
    text: 'Edit Availability',
  },
  {
    id: CalendarScheduleModes.INTERVIEW,
    text: 'Schedule Interview',
  },
] as const;

export type CalendarScheduleModeValueType =
  (typeof CalendarScheduleModes)[keyof typeof CalendarScheduleModes];
